module.exports = __webpack_public_path__ + "static/media/digital_picture_white.3e56ea39.svg";